const COLORS = {
  BLACK: "black",
  RED: "red",
  GREEN: "green",
  HX_BLACK: "#000",
  LGT_BLACK: "rgba(0,0,0,0.8)",
  TITLE: "#333",
  SB_TITLE: "#555",
  SB_HEADING: "#aaa",
  HX_WHITE: "#fff",
  ORANGE: "orange",
  FOOTER: "#777",
  HAMBURGER: "#FF0098",
  AUTH_HEADING: "#47c69c",
  BTN_THEME: "#6959cc",
  BTN_IN_ACTIVE_TXT: "#121010",
  TIMER_TXT: "rgba(0,0,0,0.5)",
  LGT_BLUE: "#1e90ff",

  BORDER_CLR: "#6959cc",
  LGT_BORDER: "#ccc",

  BG_LOADING: "rgba(0,0,0,0.5)",
  BG_DSHBRD_LAYOUT: "#f5f6fa",
  NAV_BAR: "#E23F44",
  BG_LGT_CARD: "#f9f9f9",
  BG_INPUT_FLD: "#f8f7f7",
  BG_INPUT: "#f5f5f5",

  GRPH_X_AXS_STROKE: "#8884d8",
  GRPH_BAR_FILL: "#6A5ACD",

  PENDG_PYMNT: "#e7bc3a",
  PAID_PYMNT: "#34a754",

  PENDG_BRDR: "#eb435a",
  COMPLETED_BRDR: "#6fd76f",
  IN_PRGRS_BRDR: "#ead647",

  COMPLETED_BGC: "#e4ffe4",
  PNDNG_BGC: "#fdebef",
  INPRGRS_BGC: "#fffbe3",
};

const FLEX = {
  LEFT: "left",
  STRT: "start",
  RIGHT: "right",
  CNTR: "center",
  FX_END: "flex-end",
  FX_START: "flex-start",
  EVNLY: "space-evenly",
  BETWN: "space-between",
  AROUND: "space-around",
};

const DIRCTNS = {
  ROW: "row",
  COLMN: "column",
};

export default { COLORS, FLEX, DIRCTNS };
